



































import Vue from 'vue'
import SeismicForm from '@/models/SeismicForm'
import Inspector from '@/models/Inspector'

export default Vue.extend({
  name: 'team-signature',
  props: {
    form: { type: [SeismicForm, Object] },
    signatureDate: { type: String }
  },
  computed: {
    seismicInspector (): Inspector {
      if (this.form.inspectors[0] && this.form.inspectors[0].SQUGDate && !isNaN(this.form.inspectors[0].SQUGDate)) {
        return this.form.inspectors[0] || new Inspector('', '', '')
      } else {
        return this.form.inspectors[1] || new Inspector('', '', '')
      }
    },
    installationInspector (): Inspector {
      if (this.form.inspectors[0] && this.form.inspectors[0].SQUGDate && !isNaN(this.form.inspectors[0].SQUGDate)) {
        return this.form.inspectors[1] || new Inspector('', '', '')
      } else {
        return this.form.inspectors[0] || new Inspector('', '', '')
      }
    }

  }
})

